import { render } from "./editSettingDialog.vue?vue&type=template&id=95fa5864"
import script from "./editSettingDialog.vue?vue&type=script&lang=js"
export * from "./editSettingDialog.vue?vue&type=script&lang=js"

import "./editSettingDialog.vue?vue&type=style&index=0&id=95fa5864&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__